import '@/assets/css/main.css';
import { createApp } from 'vue';
import { store } from '@/stores';
import dialog from '@/components/modal';
import App from './kpi.vue';
import { router } from './router';
import antd from 'ant-design-vue';
import components from '@/components';
import VxeUIAll from 'vxe-pc-ui';
import 'vxe-pc-ui/es/style.css';
import VxeUITable from 'vxe-table';
import 'vxe-table/es/style.css';
import '@/assets/css/font-awesome-4.7.0/css/font-awesome.min.css';
import { loadAntIcons } from '@/hooks';
import 'ant-design-vue/dist/reset.css';
import shareComponents from '@/share/components/xeui';

const app = createApp(App);

// 加载ant-design-vue图标库
loadAntIcons(app);

app.use(antd)
    .use(VxeUIAll)
    .use(VxeUITable)
    .use(shareComponents)
    .use(components)
    .use(store)
    .use(router)
    .use(dialog).mount('#app');
